import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "topBar" }
const _hoisted_2 = { class: "switchBar" }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        size: "large",
        type: "primary",
        onClick: _ctx.addAd
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("添加通知", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "id",
            prop: "id"
          }),
          _createVNode(_component_el_table_column, {
            label: "标题",
            prop: "title"
          }),
          _createVNode(_component_el_table_column, {
            label: "信息",
            prop: "info"
          }),
          _createVNode(_component_el_table_column, {
            label: "标号",
            prop: "signOrder"
          }),
          _createVNode(_component_el_table_column, {
            label: "创建时间",
            prop: "createTime",
            align: "center"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
        width: "500",
        draggable: "",
        "show-close": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = false))
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("取消", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.submitReply
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isAdd ? "增加" : "修改"), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            "label-width": "auto",
            style: {"max-width":"600px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "标题" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                    type: "text",
                    maxlength: "20",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "链接" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.noticeLink,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.noticeLink) = $event)),
                    type: "text",
                    maxlength: "100",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "信息" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.info,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.info) = $event)),
                    type: "textarea",
                    autosize: { minRows: 5 }
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          total: _ctx.total,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["total", "onCurrentChange"])
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ], 64))
}